import { render, staticRenderFns } from "./StorageBaseMinio.vue?vue&type=template&id=3b480214&"
import script from "./StorageBaseMinio.vue?vue&type=script&lang=js&"
export * from "./StorageBaseMinio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports